import PageHeader from "@/components/common/PageHeader";
import SeoHead from "@/components/common/SeoHead";
import { Sparkles } from "lucide-react";
import { ABOUT } from "@/data/content";
import { useSettings } from "@/context/SettingsContext";
import { getImageUrl } from "@/lib/api";

export default function Projects() {
  const { settings } = useSettings();
  const pageData = settings?.projects_page || {};

  const title = pageData.title || "Proyek & Intervensi Berkelanjutan";
  const desc = pageData.description || "Inisiatif kolaboratif yang menghubungkan berbagai sumber daya untuk menghasilkan dampak yang lebih luas.";

  return (
    <div data-testid="page-projects">
      <SeoHead title={{ id: "Proyek", en: "Projects" }} description={{ id: desc, en: "Discover ongoing and completed projects by Sauyunan Foundation." }} />
      <PageHeader
        eyebrow="Proyek Strategis"
        title={title}
        description={desc}
        image={getImageUrl("https://images.unsplash.com/photo-1593113565694-c6f17c2445b4?w=1000&q=80")}
      />

      <section className="section-y bg-white">
        <div className="container-sf">
          <div className="grid lg:grid-cols-[1fr,1.6fr] gap-12">
            <div>
              <div className="eyebrow mb-3">Flagship Programs</div>
              <h2 className="text-4xl font-bold text-slate-900 leading-tight">Lima program unggulan yang menjadi identitas Sauyunan</h2>
              <p className="mt-4 text-slate-600 leading-relaxed">
                Program-program unggulan kami dirancang untuk menciptakan model pembangunan yang menghasilkan manfaat sosial, ekonomi, dan lingkungan secara simultan.
              </p>
            </div>
            <div className="space-y-4">
              {FLAGSHIP.map((f, i) => (
                <div key={i} className="card-sf p-6 flex gap-5" data-testid={`project-flagship-${i}`}>
                  <div className="marker-num text-4xl leading-none shrink-0">0{i + 1}</div>
                  <div>
                    <div className="text-xs font-semibold uppercase tracking-wider text-[var(--brand-orange)] mb-1">Flagship</div>
                    <h3 className="text-xl font-bold text-slate-900">{f.title}</h3>
                    <p className="mt-2 text-slate-600 leading-relaxed text-sm">{f.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Impact model */}
      <section className="section-y bg-[var(--bg)]">
        <div className="container-sf">
          <div className="max-w-3xl mb-12">
            <div className="eyebrow mb-3">Metodologi</div>
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight">Setiap proyek menempuh lima tahap</h2>
          </div>
          <div className="grid md:grid-cols-5 gap-4">
            {ABOUT.impactModel.map((s, i) => (
              <div key={s.stage} className="card-sf p-6">
                <div className={`h-12 w-12 rounded-xl ${i % 2 === 0 ? "bg-[var(--brand-blue)]" : "bg-[var(--brand-orange)]"} text-white font-bold flex items-center justify-center mb-4`}>{s.stage}</div>
                <h4 className="text-lg font-bold text-slate-900">{s.title}</h4>
                <p className="mt-2 text-xs text-slate-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Note about projects list */}
      <section className="pb-24">
        <div className="container-sm">
          <div className="rounded-2xl bg-[var(--brand-soft-blue)] p-8 text-center">
            <Sparkles className="h-8 w-8 text-[var(--brand-blue)] mx-auto mb-3" />
            <h3 className="text-xl font-bold text-slate-900 mb-2">Detail proyek segera hadir</h3>
            <p className="text-slate-600">Portfolio proyek Sauyunan Foundation lengkap dengan studi kasus, mitra, dan indikator dampak akan segera dipublikasikan.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

const FLAGSHIP = [
  { title: "Sauyunan Bioeconomy Initiative", body: "Program unggulan yang mengembangkan ekosistem terintegrasi berbasis ketahanan pangan, bioenergi, biomassa, karbon, dan pemberdayaan masyarakat melalui pemanfaatan sumber daya lokal." },
  { title: "Sauyunan Humanity Response", body: "Program kemanusiaan yang berfokus pada bantuan darurat, respon bencana, pemulihan masyarakat terdampak, dan penguatan ketahanan komunitas." },
  { title: "Sauyunan Nutrition For Future", body: "Program peningkatan kualitas gizi dan kesehatan masyarakat untuk mendukung generasi yang sehat dan produktif." },
  { title: "Sauyunan Green Impact", body: "Program yang berfokus pada konservasi lingkungan, rehabilitasi ekosistem, pengembangan karbon, dan aksi perubahan iklim." },
  { title: "Sauyunan Future Leaders", body: "Program pengembangan pendidikan, kepemimpinan, karakter, dan kapasitas generasi masa depan." },
];
